import { get, isFunction } from 'lodash';

export const hasInvalidAdditionalStatuses = (data, parameters) =>
  Object.entries(parameters).some(([key, value]) => get(data, key) !== value);

export const evaluateConditions = (data, conditions) => {
  if (conditions.length === 0) return true;
  if (!data) return false;
  return !conditions.some(
    ({ conditionId, parameters }) =>
      !(
        isFunction(CONDITIONS[conditionId]) &&
        CONDITIONS[conditionId](data, parameters)
      ),
  );
};

export const CONDITIONS = {
  'is-agency-status-includes': (data, parameters) =>
    parameters.includes(get(data, 'agency.status')),
  'is-agency-status-not-includes': (data, parameters) =>
    !parameters.includes(get(data, 'agency.status')),
  'has-invalid-additional-statuses': hasInvalidAdditionalStatuses,
};
